import {createRouter, createWebHistory, RouteRecordRaw} from "vue-router";
import {store,} from "@mfksoft/utils";
import Layout from "@/layout/index.vue";
import SecondLayout from "@/layout/2nd.vue";
import {ref} from "vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login.vue"),
        meta: {title: "登录"}
    },
    {
        path: "/home",
        name: "Home",
        component: () => import("@/views/home.vue"),
        meta: {title: "首页"}
    },
    {
        path: "/",
        component: Layout,
        redirect: "/sys/u", //暂时重定向到模块管理
        children: [
            {
                path: "/sys",
                name: "Sys",
                component: SecondLayout,
                meta: {title: "系统管理"},
                children: [
                    {
                        path: "u",
                        name: "User",
                        component: () => import("@/views/sys/user.vue"),
                        meta: {title: "用户&角色管理"}
                    },
                ]
            },]
    },
];

const router = createRouter({
// @ts-ignore
    history: createWebHistory(import.meta.env.BASE_URL), // ✅ 正确写法
    routes
});

const siteName = ref("魔方点单系统管理");


router.beforeEach(async (to) => {
    if (!store.GetToken() && to.name !== "Login") {
        console.log("未登录，跳转登录页")
        return {name: "Login", query: {redirect: to.fullPath}}
    }

    window.document.title = ` ${to.meta.title} - ${siteName.value}`;
});

export default router;
